import { getBusiness } from "@/data/business";

const KEY = "cmm_submissions";

export const loadAll = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

const saveAll = (list) => localStorage.setItem(KEY, JSON.stringify(list));

export const getSubmission = (id) => loadAll().find((s) => s.id === id) || null;

export const upsertSubmission = (sub) => {
  const list = loadAll();
  const i = list.findIndex((s) => s.id === sub.id);
  if (i >= 0) list[i] = sub;
  else list.unshift(sub);
  saveAll(list);
  return sub;
};

export const removeSubmission = (id) => saveAll(loadAll().filter((s) => s.id !== id));

export const createSubmission = (respondent, mode = "guided") =>
  upsertSubmission({
    id: crypto.randomUUID(),
    respondent,
    mode,
    businessType: getBusiness().type,
    businessName: getBusiness().name,
    businessId: getBusiness().id,
    createdAt: new Date().toISOString(),
    status: "draft",
    sectionIndex: 0,
    answers: {},
    report: "",
    reportDone: false,
  });

export const formatDate = (iso) =>
  new Date(iso).toLocaleString("it-IT", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });

const WEIGHTS_KEY = "cmm_weights";

export const loadWeights = () => {
  try {
    return JSON.parse(localStorage.getItem(WEIGHTS_KEY) || "{}");
  } catch {
    return {};
  }
};

export const saveWeights = (w) => localStorage.setItem(WEIGHTS_KEY, JSON.stringify(w));

export const upsertStaff = (subId, entry) => {
  const sub = getSubmission(subId);
  if (!sub) return null;
  const staff = sub.staff || [];
  const i = staff.findIndex((p) => p.id === entry.id);
  if (i >= 0) staff[i] = entry;
  else staff.push(entry);
  upsertSubmission({ ...sub, staff });
  return entry;
};

export const removeStaff = (subId, staffId) => {
  const sub = getSubmission(subId);
  if (sub) upsertSubmission({ ...sub, staff: (sub.staff || []).filter((p) => p.id !== staffId) });
};

const METHODS_KEY = "cmm_metodi";

export const loadMethods = () => {
  try {
    return JSON.parse(localStorage.getItem(METHODS_KEY) || "[]");
  } catch {
    return [];
  }
};

export const upsertMethod = (m) => {
  const list = loadMethods();
  const i = list.findIndex((x) => x.id === m.id);
  if (i >= 0) list[i] = m;
  else list.unshift(m);
  localStorage.setItem(METHODS_KEY, JSON.stringify(list));
  return m;
};

export const removeMethod = (id) => localStorage.setItem(METHODS_KEY, JSON.stringify(loadMethods().filter((x) => x.id !== id)));

const TERRITORY_KEY = "cmm_territorio";

export const loadTerritories = () => {
  try {
    return JSON.parse(localStorage.getItem(TERRITORY_KEY) || "[]");
  } catch {
    return [];
  }
};

export const upsertTerritory = (t) => {
  const list = loadTerritories();
  const i = list.findIndex((x) => x.id === t.id);
  if (i >= 0) list[i] = t;
  else list.unshift(t);
  localStorage.setItem(TERRITORY_KEY, JSON.stringify(list));
  return t;
};

export const removeTerritory = (id) => localStorage.setItem(TERRITORY_KEY, JSON.stringify(loadTerritories().filter((x) => x.id !== id)));
